import store from "./store/store.js";

const checkIfLoggedIn = function(to) {
  if (to.matched.some(record => record.meta.requires_auth)) {
    if (!store.getters["user/is_logged_in"]) return { path: "/signin" };
  }
  return null;
};

const checkIfMailIsVerified = function(to) {
  if (to.matched.some(record => record.meta.requires_verified_mail)) {
    if (!store.getters["user/has_verified_mail"]) return { path: "/verify" };
  }
  return null;
};

const navigation_guards = [checkIfLoggedIn, checkIfMailIsVerified];

export default navigation_guards;
